import { ChainId } from '@donaswap/sdk'
import { NetworkAlertChains } from './ShouldShowAlert'

export const TEXT_COLORS: { [chainId in NetworkAlertChains]: string } = {
  [ChainId.FIRECHAIN]: '#CDA800',
  [ChainId.RINIA]: '#878E95',
  [ChainId.ETHEREUM]: '#627FEB',
  [ChainId.GOERLI]: '#627FEB',
  [ChainId.SEPOLIA]: '#627FEB',
  [ChainId.BSC]: '#F0BA03',
  [ChainId.BSC_TESTNET]: '#F0BA03',
  [ChainId.POLYGON]: '#8247E5',
  [ChainId.POLYGON_MUMBAI]: '#8247E5',
  [ChainId.POLYGON_ZKEVM]: '#8247E5',
  [ChainId.POLYGON_ZKEVM_TESTNET]: '#8247E5',
  [ChainId.CRO]: '#243367',
  [ChainId.CRO_TESTNET]: '#243367',
  [ChainId.AVALANCHE]: '#E84142',
  [ChainId.AVALANCHE_FUJI]: '#E84142',
  [ChainId.FANTOM_OPERA]: '#13B5EC',
  [ChainId.FANTOM_TESTNET]: '#13B5EC',
  [ChainId.CELO]: '#35D07F',
  [ChainId.CELO_ALFAJORES]: '#35D07F',
  [ChainId.OPTIMISM]: '#FF0420',
  [ChainId.OPTIMISM_GOERLI]: '#FF0420',
  [ChainId.ARBITRUM_ONE]: '#28A0F0',
  [ChainId.ARBITRUM_GOERLI]: '#28A0F0',
  [ChainId.SHIBARIUM]: '#FFA502',
  [ChainId.SHIBARIUM_TESTNET]: '#FFA502',
  [ChainId.PULSECHAIN]: '#7C00FF',
  [ChainId.PULSECHAIN_TESTNET]: '#7C00FF',
  [ChainId.XEN]: '#000000',
  [ChainId.XEN_DEVNET]: '#000000',
  [ChainId.HARMONY]: '#2ECFD6',
  [ChainId.HARMONY_TESTNET]: '#2ECFD6',
  [ChainId.COINEX]: '#4E4EFF',
  [ChainId.COINEX_TESTNET]: '#4E4EFF',
  [ChainId.DOGECHAIN]: '#9255FA',
  [ChainId.DOGECHAIN_TESTNET]: '#9255FA',
  [ChainId.ETHEREUM_CLASSIC]: '#2E842E',
  [ChainId.ETHEREUM_CLASSIC_TESTNET]: '#2E842E',
  [ChainId.FUSION]: '#122E5A',
  [ChainId.FUSION_TESTNET]: '#122E5A',
  [ChainId.HECO]: '#31AD58',
  [ChainId.HECO_TESTNET]: '#31AD58',
  [ChainId.KCC]: '#3EE6AF',
  [ChainId.KCC_TESTNET]: '#3EE6AF',
  [ChainId.KLAYTN]: '#A80106',
  [ChainId.KLAYTN_BAOBAB]: '#A80106',
  [ChainId.OKXCHAIN]: '#000000',
  [ChainId.OKXCHAIN_TESTNET]: '#000000',
  [ChainId.THETHA]: '#25B9E7',
  [ChainId.THETHA_TESTNET]: '#25B9E7',
  [ChainId.ULTRON]: '#3E09A2',
  [ChainId.ULTRON_TESTNET]: '#3E09A2',
  [ChainId.MOONBEAM]: '#171E43',
  [ChainId.MOONRIVER]: '#F3B705',
  [ChainId.MOONBASE_ALPHA]: '#171E43',
  [ChainId.AURORA]: '#6ED34A',
  [ChainId.AURORA_TESTNET]: '#6ED34A',
  [ChainId.BOBA]: '#1CD8D2',
  [ChainId.BOBA_GOERLI]: '#1CD8D2',
  [ChainId.GNOSIS]: '#00193C',
  [ChainId.GNOSIS_CHIADO]: '#00193C',
  [ChainId.METIS]: '#00CFC2',
  [ChainId.METIS_GOERLI]: '#00CFC2',
  [ChainId.TELOS]: '#6D4BB8',
  [ChainId.TELOS_TESTNET]: '#6D4BB8',
  [ChainId.SYSCOIN]: '#1F5EFF',
  [ChainId.SYSCOIN_TANENBAUM]: '#1F5EFF',
  [ChainId.IOTEX]: '#00D4D5',
  [ChainId.IOTEX_TESTNET]: '#00D4D5',
  [ChainId.SHIDEN]: '#AF68FF',
  [ChainId.ASTAR]: '#0077EE',
  [ChainId.SHIBUNYA]: '#AF68FF',
  [ChainId.FUSE]: '#B8FCA4',
  [ChainId.FUSE_SPARKNET]: '#B8FCA4',
  [ChainId.VELAS]: '#0037C1',
  [ChainId.VELAS_TESTNET]: '#0037C1',
  [ChainId.REI]: '#2116E5',
  [ChainId.REI_TESTNET]: '#2116E5',
  [ChainId.KEKCHAIN]: '#18783C',
  [ChainId.KEKCHAIN_TESTNET]: '#18783C',
  [ChainId.TOMOCHAIN]: '#00E9B4',
  [ChainId.TOMOCHAIN_TESTNET]: '#00E9B4',
  [ChainId.THUNDERCORE]: '#00D6E9',
  [ChainId.THUNDERCORE_TESTNET]: '#00D6E9',
  [ChainId.WANCHAIN]: '#136AAD',
  [ChainId.WANCHAIN_TESTNET]: '#136AAD',
  [ChainId.RSK]: '#4F7B3D',
  [ChainId.RSK_TESTNET]: '#4F7B3D',
  [ChainId.ELASTOS]: '#2A3D58',
  [ChainId.ELASTOS_TESTNET]: '#2A3D58',
  [ChainId.CONFLUX]: '#1F909B',
  [ChainId.CONFLUX_TESTNET]: '#1F909B',
  [ChainId.BRISECHAIN]: '#630CE5',
  [ChainId.BRISECHAIN_TESTNET]: '#630CE5',
  [ChainId.MUUCHAIN]: '#2D3FBD',
  [ChainId.MUUCHAIN_TESTNET]: '#2D3FBD',
  [ChainId.CANTO]: '#06FC99',
  [ChainId.CANTO_TESTNET]: '#06FC99',
  [ChainId.OASIS_EMERALD]: '#0089DB',
  [ChainId.OASIS_TESTNET]: '#0089DB',
  [ChainId.VISION]: '#000000',
  [ChainId.VISION_TESTNET]: '#000000',
  [ChainId.STEP]: '#F9D549',
  [ChainId.STEP_TESTNET]: '#F9D549',
  [ChainId.METER]: '#0287D0',
  [ChainId.METER_TESTNET]: '#0287D0',
  [ChainId.GODWOKEN]: '#00CD9E',
  [ChainId.GODWOKEN_TESTNET]: '#00CD9E',
  [ChainId.CALLISTO]: '#21AE54',
  [ChainId.CALLISTO_TESTNET]: '#21AE54',
  [ChainId.EVMOS]: '#ED4E33',
  [ChainId.EVMOS_TESTNET]: '#ED4E33',
  [ChainId.ENERGY_WEB_CHAIN]: '#A566FF',
  [ChainId.ENERGY_VOLTA]: '#A566FF',
  [ChainId.BASE]: '#0052FF',
  [ChainId.BASE_GOERLI]: '#0052FF',
  [ChainId.KAVA]: '#0052FF',
  [ChainId.KAVA_TESTNET]: '#0052FF',
  [ChainId.CLOVER]: '#0052FF',
  [ChainId.CLOVER_TESTNET]: '#0052FF',
  [ChainId.DEFICHAIN]: '#0052FF',
  [ChainId.DEFICHAIN_TESTNET]: '#0052FF',
  [ChainId.BRONOS]: '#0052FF',
  [ChainId.BRONOS_TESTNET]: '#0052FF',
  [ChainId.FILECOIN]: '#0052FF',
  [ChainId.FILECOIN_CALIBRATION]: '#0052FF',
  [ChainId.FLARE]: '#0052FF',
  [ChainId.FLARE_TESTNET]: '#0052FF',
  [ChainId.TARAXA]: '#0052FF',
  [ChainId.TARAXA_TESTNET]: '#0052FF',
  [ChainId.ZKSYNC]: '#0052FF',
  [ChainId.ZKSYNC_TESTNET]: '#0052FF',
  [ChainId.LINEA_TESTNET]: '#0052FF',
}
